import { Colors } from '../../../../themes/colors';

export const InfoRow = ({ children, style = {} }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '12px 10px',
      borderBottom: `1px solid ${Colors.neutral_200}`,
      ...style,
    }}
  >
    {children}
  </div>
);
